"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductOfferingAttachmentByAttachmentType = exports.isNovum = exports.getCQActionNameByCode = exports.getProductPromotionTextByTextType = exports.getProductOfferingTextByTextType = void 0;

var _gerenciatdTelcovid = require("@bit/gerenciatd.telcovid.catalog-constants");

var _gerenciatdUtils = require("@bit/gerenciatd.utils.js-utils");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.tagging-utils");

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getCatalogTextByTextType = function getCatalogTextByTextType(textStructure, textType, taggingStructure) {
  var text = '';

  if (textStructure) {
    if (textStructure.texts && Array.isArray(textStructure.texts)) {
      var textObj = textStructure.texts.find(function (element) {
        return element.typeId === textType;
      });

      if (textObj) {
        text = textObj.text;
      }
    }

    if (!text) {
      (0, _gerenciatdUtils2.sendCustomTaggingWithParams)(taggingStructure, [textType, textStructure.id]);
    }
  }

  return text;
};

var getProductOfferingTextByTextType = function getProductOfferingTextByTextType(productOffering, textType, processName) {
  var taggingStructure = _objectSpread(_objectSpread({}, _constants.GTM_PRODUCT_OFFERING_TEXT_EMPTY), {}, {
    GAlabel: processName
  });

  return getCatalogTextByTextType(productOffering, textType, taggingStructure);
};

exports.getProductOfferingTextByTextType = getProductOfferingTextByTextType;

var getProductPromotionTextByTextType = function getProductPromotionTextByTextType(productPromotion, textType, processName) {
  var taggingStructure = _objectSpread(_objectSpread({}, _constants.GTM_PRODUCT_PROMOTION_TEXT_EMPTY), {}, {
    GAlabel: processName
  });

  return getCatalogTextByTextType(productPromotion, textType, taggingStructure);
};

exports.getProductPromotionTextByTextType = getProductPromotionTextByTextType;

var getCQActionNameByCode = function getCQActionNameByCode(cqActionCode) {
  var keyName = _gerenciatdUtils.common.getPropKeyByValue(_gerenciatdTelcovid.CQ_ACTION_CODES, cqActionCode);

  return _gerenciatdTelcovid.CQ_ACTION_NAME[keyName] || '';
};

exports.getCQActionNameByCode = getCQActionNameByCode;

var isNovum = function isNovum() {
  return sessionStorage.getItem('canalVenta') === 'appNovum';
};

exports.isNovum = isNovum;

var getAttachmentByAttachmentType = function getAttachmentByAttachmentType(productOfferingStructure, attachmentType, taggingStructure) {
  var attachmentSelected = null;

  if (productOfferingStructure) {
    if (productOfferingStructure.attachments && Array.isArray(productOfferingStructure.attachments)) {
      attachmentSelected = productOfferingStructure.attachments.find(function (element) {
        return element.attachmentType && element.attachmentType.id === attachmentType;
      });
    }

    if (!attachmentSelected) {
      (0, _gerenciatdUtils2.sendCustomTaggingWithParams)(taggingStructure, [attachmentType, productOfferingStructure.productOffering]);
    }
  }

  return attachmentSelected;
};

var getProductOfferingAttachmentByAttachmentType = function getProductOfferingAttachmentByAttachmentType(productOffering, attachmentType, processName) {
  var taggingStructure = _objectSpread(_objectSpread({}, _constants.GTM_PRODUCT_OFFERING_ATTACHMENT_EMPTY), {}, {
    GAlabel: processName
  });

  return getAttachmentByAttachmentType(productOffering, attachmentType, taggingStructure);
};

exports.getProductOfferingAttachmentByAttachmentType = getProductOfferingAttachmentByAttachmentType;

//# sourceMappingURL=index.js.map